import { render, staticRenderFns } from "./Next-lesson.vue?vue&type=template&id=129d58f0&scoped=true&lang=html"
import script from "./Next-lesson.vue?vue&type=script&lang=js"
export * from "./Next-lesson.vue?vue&type=script&lang=js"
import style0 from "./Next-lesson.vue?vue&type=style&index=0&id=129d58f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129d58f0",
  null
  
)

export default component.exports